import { IContentKey } from '../interfaces';

export class ContentKeys {
  [key: string]: IContentKey;

  static TermsAndConditions_Url: IContentKey = {
    id: 'TermsAndConditions_Url',
    value: '',
  };

  static LegalDocument1_Link: IContentKey = {
    id: 'LegalDocument1_Link',
    value: '',
  };

  static LegalDocument2_Link: IContentKey = {
    id: 'LegalDocument2_Link',
    value: '',
  };

  static LegalDocument3_Link: IContentKey = {
    id: 'LegalDocument3_Link',
    value: '',
  };

  static LegalDocument4_Link: IContentKey = {
    id: 'LegalDocument4_Link',
    value: '',
  };

  static LegalDocument5_Link: IContentKey = {
    id: 'LegalDocument5_Link',
    value: '',
  };

  static LegalDocument6_Link: IContentKey = {
    id: 'LegalDocument6_Link',
    value: '',
  };

  static LegalDocument7_Link: IContentKey = {
    id: 'LegalDocument7_Link',
    value: '',
  };

  static LegalDocument8_Link: IContentKey = {
    id: 'LegalDocument8_Link',
    value: '',
  };

  static PrivacyPolicy_Url: IContentKey = {
    id: 'PrivacyPolicy_Url',
    value: '',
  };
}
